export default __webpack_public_path__ + "static/supportImg1-d46ee1ace014f4bd0d6fc365de78f2ee.png";